( function( $ ) {
	let initBlock = function( section = false ) {	
		const $section = section ? $( section ) : $( '.section-related' );

		const relatedSlider = function() {
			$section.each( function() {
				const $sectionInstance = $( this );
	
				$sectionInstance.find( '.js-recent-blogs-slider' ).each( function() {
					const $slider = $( this );
	
					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}
	
					new Swiper( $slider[0], {
						slidesPerView: 1,
						spaceBetween: 0,
						loop: true,
						speed: 1000,
						effect: 'fade',
						fadeEffect: {
							crossFade: true,
						},
						navigation: {
							nextEl: $slider.find( '.swiper-button-next' )[0],
							prevEl: $slider.find( '.swiper-button-prev' )[0],
						},
						pagination: {
							el: $slider.find( '.swiper-pagination' )[0],
							type: 'fraction',
						}
					} );
				} );
			} );
		};

		window.app.loadVendor( 'Swiper', relatedSlider );
	};
	
	window.app.loadBlock( initBlock, 'section-related', '.section-related' );
} )( jQuery );